import { render } from "./DesktopMegaNav.vue?vue&type=template&id=3f9463e7&scoped=true"
import script from "./DesktopMegaNav.vue?vue&type=script&lang=js"
export * from "./DesktopMegaNav.vue?vue&type=script&lang=js"

import "./DesktopMegaNav.vue?vue&type=style&index=0&id=3f9463e7&lang=scss&scoped=true"
import "./DesktopMegaNav.vue?vue&type=style&index=1&id=3f9463e7&lang=scss"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9463e7"]])

export default __exports__